import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import './BKModal.css';

const BKModal = ({
  open,
  onClose,
  onOk,
  title,
  children,
  okText = 'Đồng ý',
  cancelText = 'Thoát',
  width = 600,
  confirmClose = true,
  confirmCloseMessage = 'Bạn có chắc chắn muốn đóng không? Các thay đổi chưa lưu sẽ bị mất.',
  footer,
  loading = false,
  closable = true,
  maskClosable = true,
  hasChanges = false,
  ...restProps
}) => {
  const handleClose = () => {
    if (confirmClose && hasChanges) {
      Modal.confirm({
        title: 'Xác nhận',
        content: confirmCloseMessage,
        okText: 'Đóng',
        cancelText: 'Hủy',
        onOk: () => {
          onClose();
        },
        centered: true
      });
    } else {
      onClose();
    }
  };

  const handleOk = () => {
    if (onOk) {
      onOk();
    }
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      onOk={handleOk}
      title={title}
      width={width}
      footer={footer}
      okText={okText}
      cancelText={cancelText}
      closable={closable}
      maskClosable={maskClosable}
      confirmLoading={loading}
      centered
      className="bk-modal"
      {...restProps}>
      {children}
    </Modal>
  );
};

BKModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onOk: PropTypes.func,
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  width: PropTypes.number,
  confirmClose: PropTypes.bool,
  confirmCloseMessage: PropTypes.string,
  footer: PropTypes.node,
  loading: PropTypes.bool,
  closable: PropTypes.bool,
  maskClosable: PropTypes.bool,
  zIndex: PropTypes.number,
  hasChanges: PropTypes.bool
};

export default BKModal;
